<template>
    <div class="mainbusinessModal1Warp">
        <div class="moduleTitle">现场招聘会服务</div>
        <div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position='top' :validate-on-rule-change="false">
                <div class="dialogformCenter">
                    <div class="bigTitle">一、从业人员</div>
                    <el-form-item label="1.从业人员总数：" prop="1">
                        <el-input v-model="ruleForm[1]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="2.现场招聘会现场工作人员与展位数量比例不小于1:10 ：" prop="2">
                        <el-radio-group v-model="ruleForm[2]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="3.100个以下占位的现场工作人员不少于10个：" prop="3">
                        <el-radio-group v-model="ruleForm[3]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="4.本科及以上学历比例（%）：" prop="4">
                        <el-input v-model="ruleForm[4]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">二、年举办现场招聘会次数</div>
                    <el-form-item label="5.是否是不定期现场招聘会：" prop="5">
                        <el-radio-group v-model="ruleForm[5]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="6.（不定期现场招聘会）主办或协会合计每年不少于多少次：" prop="6">
                        <el-input v-model="ruleForm[6]" placeholder="请输入"></el-input>
                    </el-form-item>

                    <el-form-item label="7.（定期现场招聘会）每月不少于多少次" prop="7">
                        <el-input v-model="ruleForm[7]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">三、现场招聘会参会人员数量</div>
                    <el-form-item label="8.是否是不定期现场招聘会：" prop="8">
                        <el-radio-group v-model="ruleForm[8]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="9.（不定期现场招聘会）大型现场招聘会场均参会人员数量不少于多少人" prop="9">
                        <el-input v-model="ruleForm[9]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="10.（不定期现场招聘会）中型现场招聘会场均参会人员数量不少于多少人：" prop="10">
                        <el-input v-model="ruleForm[10]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="11.（不定期现场招聘会）小型现场招聘会场均参会人员数量不少于多少人：" prop="11">
                        <el-input v-model="ruleForm[11]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label=" 12.（定期现场招聘会）场均参会人员数量不少于多少人：" prop="12">
                        <el-input v-model="ruleForm[12]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">四、现场招聘会参会单位数量</div>
                    <el-form-item label="13.是否是不定期现场招聘会：" prop="13">
                        <el-radio-group v-model="ruleForm[13]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label=" 14.（不定期现场招聘会）大型现场招聘会场均参会单位不少于多少个：" prop="14">
                        <el-input v-model="ruleForm[14]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label=" 15.（不定期现场招聘会）中型现场招聘会场均参会单位不少于多少个：" prop="15">
                        <el-input v-model="ruleForm[15]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label=" 16.（不定期现场招聘会）小型现场招聘会场均参会单位不少于多少个：" prop="16">
                        <el-input v-model="ruleForm[16]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label=" 17.（定期现场招聘会）场均参会单位不少于多少个：" prop="17">
                        <el-input v-model="ruleForm[17]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">五、现场招聘会提供工作岗位数量</div>
                    <el-form-item label="18.是否是不定期现场招聘会：" prop="18">
                        <el-radio-group v-model="ruleForm[18]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label=" 19.（不定期现场招聘会）大型现场招聘会场均工作岗位数量不少于多少个：" prop="19">
                        <el-input v-model="ruleForm[19]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="20.（不定期现场招聘会）中型现场招聘会场均工作岗位不少于多少个：" prop="20">
                        <el-input v-model="ruleForm[20]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="21.（不定期现场招聘会）小型现场招聘会场均工作岗位不少于多少个：" prop="21">
                        <el-input v-model="ruleForm[21]" placeholder="请输入"></el-input>
                    </el-form-item>

                    <el-form-item label="22.（定期现场招聘会）场均工作岗位不少于多少个：" prop="22">
                        <el-input v-model="ruleForm[22]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">六、安全工作落实情况</div>
                    <el-form-item label="23.具有安全保卫、安全消防方案及突发事件应急预案：" prop="23">
                        <el-radio-group v-model="ruleForm[23]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="24.安保人员数量不低于参会人员流量的8%：" prop="24">
                        <el-radio-group v-model="ruleForm[24]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="25.招聘会现场安全设施、场地面积、通道出口达到标准规定：" prop="25">
                        <el-radio-group v-model="ruleForm[25]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="26.多少年内举办的招聘会无事故率100%：" prop="26">
                        <el-input v-model="ruleForm[26]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">七、公益性现场专场招聘会次数</div>
                    <el-form-item label="27.公益性专场现场招聘会次数每年多少次" prop="27">
                        <el-input v-model="ruleForm[27]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">八、材料归档</div>
                    <el-form-item label="28.材料归档率（%）：" prop="28">
                        <el-input v-model="ruleForm[28]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="29.现场招聘会工作总结、各种数据统计报表等材料上报主管部门备案率为（%）：" prop="29">
                        <el-input v-model="ruleForm[29]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">九、客户投诉记录及处理</div>
                    <el-form-item label="30.设有投诉电话：" prop="30">
                        <el-radio-group v-model="ruleForm[30]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="31.从接到投诉到介入处理时间不超过多少个工作日，并能及时向当事人反馈处理结果：" prop="31">
                        <el-input v-model="ruleForm[31]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="32.有投诉及处理情况记录" prop="32">
                        <el-radio-group v-model="ruleForm[32]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <!-- <el-form-item label="32.有投诉及处理情况记录：" prop="32">
                                    <el-input v-model="ruleForm[32]" placeholder="请输入"></el-input>
                                </el-form-item> -->

                    <el-form-item label="33.投诉及处理情况记录保留多少年以上：" prop="33">
                        <el-input v-model="ruleForm[33]" placeholder="请输入"></el-input>
                    </el-form-item>
                </div>
                <div class="dialogformBottomBtnBox" v-if="!result">
                    <el-button type="primary" @click="saveForm" class="submitBtn">保存</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')" class="submitBtn">提交</el-button>
                    <el-button @click="cancelForm" class="cancelBtn">关闭</el-button>
                </div>
                <div class="dialogformBottomBtnBox" v-else>
                    <el-button @click="cancelForm" class="cancelBtn">关闭</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
import { httpService } from "@/service/httpService";
export default {
    props: ['result', 'saveId'],
    data() {
        return {
            ruleForm: {
                1: '',
                2: '',
                3: '',
                4: '',
                5: '',
                6: '',
                7: '',
                8: '',
                9: '',
                10: '',
                11: '',
                12: '',
                13: '',
                14: '',
                15: '',
                16: '',
                17: '',
                18: '',
                19: '',
                20: '',
                21: '',
                22: '',
                23: '',
                24: '',
                25: '',
                26: '',
                27: '',
                28: '',
                29: '',
                30: '',
                31: '',
                32: '',
                33: '',
            },
            rules: {
                // 正整数
                1: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                // 单选
                2: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                3: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                4: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                // 小数
                5: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                6: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                7: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                8: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                // 多选
                9: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                10: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                11: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                12: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                13: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                14: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                15: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                16: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                17: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                18: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                19: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                20: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                21: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                22: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                23: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                24: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                25: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                26: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                27: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                28: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                29: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                30: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                31: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                    // { pattern: '^[1-9]\\d{0,20}(\\.\\d{1,2})?$|^0(\\.\\d{1,2})?$', message: '请输入大于等于0的正整数，最多保留2位小数', trigger: 'blur' },
                ],
                32: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                33: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
            },
        }
    },
    created() {
        this.yetData()
    },
    methods: {
        // 提交
        submitForm(formName) {
            // 保存不通过validate检验
            this.$refs[formName].validate((valid, obj) => {
                if (valid) {
                    let NewDataList = []
                    for (const key in this.ruleForm) {
                        let obj = {}
                        obj.serialNumber = key;
                        obj.evaluateValue = this.ruleForm[key]
                        NewDataList.push(obj)
                    }
                    httpService.addScore(this.saveId,NewDataList).then(res => {
                        if (res.code == 200) {
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                            this.$emit('getyetServiceFn')
                        }
                    })
                } else {
                    let arr = []
                    for (const key in obj) {
                        if (Object.hasOwnProperty.call(obj, key)) {
                            let ele = key + '题、'
                            arr.push(ele)
                        }
                    }
                    let str = arr.join('')
                    this.$message.error(`${str}未填写，请检查！`);
                    return false;
                }
            });
        },
        // 保存
        saveForm(formName) {
            // saveB
            let NewDataList = []
            for (const key in this.ruleForm) {
                let obj = {}
                obj.serialNumber = key;
                obj.evaluateValue = this.ruleForm[key]
                NewDataList.push(obj)
            }
            httpService.saveB(this.saveId, NewDataList).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.$emit('getyetServiceFn')
                }
            })
        },
        cancelForm() {
            this.$emit('getyetServiceFn')
        },
        // 回填表单数据
        yetData() {
              httpService.getCorpIndicatorOption(this.saveId).then(res => {
                if (res.code == 200) {
                    if (res.result.length != 0) {
                        let obj = {}
                        for (const key in res.result) {
                            obj[res.result[key].serialNumber] = res.result[key].evaluateValue
                        }
                        this.ruleForm = obj
                    }
                }
            })
        },
    },
    // watch:{
    //     ruleForm:{
    //         handler(curVal,oldVal){
    //             // 自动保存
    //         },
    //         deep:true
    //     }
    // }
}
</script>
<style lang="less" scoped>
.mainbusinessModal1Warp {
	position: relative;
	.moduleTitle {
		font-size: 20px;
		font-weight: bolder;
		color: #333;
		margin-bottom: 12px;
		padding: 10px 0 10px 20px;
	}
	.dialogformCenter {
		padding: 10px;
		height: 550px;
		overflow-y: scroll;
		margin-bottom: 10px;
	}
	.dialogformCenter::-webkit-scrollbar {
		width: 8px;
		/*height: 4px;*/
	}
	.dialogformCenter::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.2);
	}
	.dialogformCenter::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}
	.dialogformBottomBtnBox {
		border-top: 1px solid #ccc;
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		padding: 20px 0 0 0;
		position: absolute;
		bottom: -70px;
		.submitBtn {
			width: 152px;
			height: 40px;
			background: #349cff;
			margin: 0 20px;
		}
		.cancelBtn {
			width: 152px;
			height: 40px;
			border: 1px solid #a6a9b7;
			border-radius: 5px;
			margin: 0 20px;
		}
	}
}
</style>


